import { render, staticRenderFns } from "./ScenicDetail.vue?vue&type=template&id=0da298e6&scoped=true&"
import script from "./ScenicDetail.vue?vue&type=script&lang=js&"
export * from "./ScenicDetail.vue?vue&type=script&lang=js&"
import style0 from "./ScenicDetail.vue?vue&type=style&index=0&id=0da298e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da298e6",
  null
  
)

export default component.exports